module.exports = __webpack_public_path__ + "img/transaction.fb27b5da.png";